import React, { useEffect, useState } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Stack,
  Button,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import SearchIcon from "@mui/icons-material/Search"
import { FetchErrorHandeling } from "../../../../../../base/errorHandeling/FetchErrorHandeling"
import api from "../../../../../../base/services/ResApi"
import Alerts from "../../../../../../base/errorHandeling/Alerts"

const OperationStatus = ({ open, onClose }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [oprType, setOprType] = useState('')
  const [isSearch, setIsSearch] = useState(false)
  const [data, setData] = useState()

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  //clear all alerts after a timeout
  useEffect(() => {
    if ((iserror) === true) {
      let timerId = setTimeout(() => {
        setIserror(false)
        setErrorMessages([])
        timerId = null
      }, 5000)
      return () => clearTimeout(timerId)
    }
  }, [iserror])

  useEffect(() => {
    const opID = localStorage.getItem(oprType)
    if (isSearch) {
      let config = {
        headers: {
          Action: "VIEW_TMNL_OPS_STATUS",
          "Ops-Request-Id": opID,
        },
      }
      api
        .get("/terminal/operations", config)
        .then((res) => {
          setIsSearch(false)
          setErrorMessages([])
          setIserror(false)
          setData(res.data?.dataList)
        })
        .catch((err) => {
          setIsSearch(false)
          FetchErrorHandeling(err, setIserror, setErrorMessages, setIserrorShow)
        })
    }
  }, [isSearch])

  const title = {
    fontSize: "14px",
    color: "#ccc",
  }

  const body = {
    fontSize: "14px",
    paddingLeft: "20px",
    paddingBottom: "20px",
    fontWeight: "550",
    width: "140px",
  }

  const handleOperTypeChange = (e) => {
    setOprType(e.target.value)
  }

  const handleClose = ()=>{
    setOprType('')
    onClose()
  }

  return (
    <Dialog
      fullWidth
      open={open}
      PaperProps={{
        style: {
          borderRadius: "10px",
          width: windowWidth >= 1500 ? "1500px" : "1320px",
          margin: 0,
        },
      }}
    >
      <DialogTitle sx={{ backgroundColor: "#116c6f", color: "#fff" }}>
        View Recent Operation Status
      </DialogTitle>
      <IconButton
        aria-label="close"
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: "#fff",
        })}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <div>
          <Alerts
            iserror={iserror}
            errorMessages={errorMessages}
            iserrorShow={iserrorShow}
          />
        </div>
        <Stack direction="row" spacing={3}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Operation Type
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              value={oprType}
              label="App Label"
              onChange={handleOperTypeChange}
            >
              <MenuItem value="TMNL_LOCK">Lock</MenuItem>
              <MenuItem value="TMNL_UNLOCK">Unlock</MenuItem>
              <MenuItem value="TMNL_SHUTDOWN">Shutdown</MenuItem>
              <MenuItem value="TMNL_RESTART">Restart</MenuItem>
              <MenuItem value="UNINSTALL_PAYT_APP">Uninstall</MenuItem>
              <MenuItem value="CLEAR_PAYT_APP_DATA">Clear Payt. App Data</MenuItem>
            </Select>
          </FormControl>
          <Button
            onClick={() => setIsSearch(true)}
            variant="contained"
            color="primary"
            startIcon={<SearchIcon />}
            size="large"
          >
            Search
          </Button>
        </Stack>
        <br />
        <br />
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <div>
            <h6 style={title}>Operation</h6>
            <p style={body}>{data?.operation}</p>
          </div>
          <div className="terminalGeneralInfoRightAlign">
            <h6 style={title}>Status</h6>
            <p style={body}>{data?.status}</p>
          </div>
          <div className="terminalGeneralInfoRightAlign">
            <h6 style={title}>Created By</h6>
            <p style={body}>{data?.createdBy}</p>
          </div>
          <div>
            <h6 style={title}>Description</h6>
            <p style={body}>{data?.desc}</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default OperationStatus
